import { NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, Component, contentChild, inject, TemplateRef } from "@angular/core";
import { BaseComponent } from "primeng/basecomponent";
import { SidenavStyle } from "./sidenav.style";

/**
 * Sidenav is used for global navigation menu.
 *
 * @example
 * ```html
 * <ui-sidenav>
 *   <p-avatar image="/app-logo.png" shape="circle" />
 *
 *   <ng-template #primary>
 *     <ui-sidenav-panel>
 *       <ui-sidenav-header>
 *         <ui-sidenav-item [label]="t('candidates.title')" icon="pi pi-users" />
 *       </ui-sidenav-header>
 *
 *       <ui-sidenav-content>
 *         <p class="text-accordion-heading mb-1">
 *           {{ t('candidates.title') }}
 *         </p>
 *
 *         <ui-sidenav-item
 *           [label]="t('candidates.edit')"
 *           icon="pi pi-users"
 *           routerLink="/app/candidates/edit" />
 *
 *         <ui-sidenav-item
 *           [label]="t('collections.edit')"
 *           icon="pi pi-list"
 *           routerLink="/app/collections/edit" />
 *       </ui-sidenav-content>
 *     </ui-sidenav-panel>
 *   </ng-template>
 *
 *   <ng-template #secondary>
 *     <!-- ... -->
 *   </ng-template>
 * </ui-sidenav>
 * ```
 */
@Component({
  selector: "ui-sidenav",
  templateUrl: "./sidenav.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet],
  host: { "[class]": "cx('root')" },
})
export class SidenavComponent extends BaseComponent {
  protected readonly _componentStyle = inject(SidenavStyle);

  protected readonly primary = contentChild.required<TemplateRef<void>>("primary");
  protected readonly secondary = contentChild<TemplateRef<void>>("secondary");
}
